// pages/im/components/message-emitter/input-message-emitter/input-message-emitter.js
import { IMEventBus } from "lib/mp-stjk-im-service";

const behaviorBase = require("behaviors/behaviorBase");
const InputType = {
    CHAT_MSG: 0,
    LEAVE_MSG: 1
};
// 占位符的展示信息
const placeHolderTips = {
    [InputType.CHAT_MSG]: "输入文字描述病情",
    [InputType.LEAVE_MSG]: "输入文字给医生留言"
};
Component({
    behaviors: [behaviorBase],
    /**
     * 组件的属性列表
     */
    properties: {
        inputProps: {
            type: Object,
            value: {},
            observer: function (inputProps) {
                this.setData({
                    mPlaceholder: inputProps.placeHolder || placeHolderTips[inputProps.inputType]
                });
            }
        }
    },

    /**
     * 组件的初始数据
     */
    data: {
        msgText: "",
        mPlaceholder: "",
        showInputPanel: true
    },

    // ready: function () { },
    ready: function() {
        let that = this 
        setTimeout(() => {
            // that.handleMsgContainerReset({'key':'test-input'});
            // that.triggerEvent("panelreset", {'key':'test-input'}, {
            //     bubbles: true,
            //     composed: true
            // });
        }, 1000);
        console.log('lld ready-------------------------------')
    },

    /**
     * 组件的方法列表
     */
    methods: {
        /**
         * 消息发送
         */
        sendMessage: function (content = '', subType = 1) {
            const data = {
                id: Date.now(),
                content,
                subType,
                type: 1
            };
            // 如果是留言 则只能发送给主医生
            // if (this.data.inputProps.inputType === InputType.LEAVE_MSG) {
            //     const pageList = getCurrentPages();
            //     data["toId"] = pageList[pageList.length - 1].doctorId;
            //     data["type"] = 4;
            // }
            // 图片渲染完需要滚动到最下方
            if (subType === 2) {
                data.isNew = true;
            }
            IMEventBus.trigger("SEND_MESSGE", data);
        },
        /**
         * 发送图片
         */
        sendImage: function (e) {
            this.sendMessage(e.detail, 2);
        },
        /**
         * 发送文本
         */
        sendText: function (e) {
            const text = e.detail;
            if (text) {
                this.sendMessage(text);
            }
        }
    }
});
